import React from "react";
import { cn } from "@/lib/format";

const MAP = {
  searching: { label: "Finding driver", cls: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400" },
  scheduled_pending: { label: "Finding driver", cls: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400" },
  scheduled: { label: "Scheduled", cls: "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400" },
  driver_enroute: { label: "On the way", cls: "bg-accent text-brand-700 dark:text-brand-400" },
  accepted: { label: "Accepted", cls: "bg-accent text-brand-700 dark:text-brand-400" },
  arrived: { label: "Arrived", cls: "bg-accent text-brand-700 dark:text-brand-400" },
  in_progress: { label: "In progress", cls: "bg-accent text-brand-700 dark:text-brand-400" },
  completed: { label: "Completed", cls: "bg-success/15 text-success" },
  cancelled: { label: "Cancelled", cls: "bg-destructive/15 text-destructive" },
  declined: { label: "Declined", cls: "bg-destructive/15 text-destructive" },
};

// A scheduled ride with no driver selected yet is still "finding a driver".
export function effectiveStatus(ride) {
  if (!ride) return "";
  if (ride.status === "scheduled" && !ride.assigned_driver) return "scheduled_pending";
  return ride.status;
}

export default function StatusBadge({ status, className = "" }) {
  const m = MAP[status] || { label: status, cls: "bg-secondary text-muted-foreground" };
  return (
    <span className={cn("rounded-full px-2.5 py-1 text-xs font-semibold", m.cls, className)}>
      {m.label}
    </span>
  );
}

export const isActiveStatus = (s) =>
  ["searching", "scheduled", "driver_enroute", "accepted", "arrived", "in_progress"].includes(s);
